var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { pxToRem } from "../../utils";
var StyledListItemCss = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme,
    $marginBottom = _ref.$marginBottom;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-left: ", "rem;\n    position: relative;\n\n    &:not(:last-child) {\n      margin-bottom: ", ";\n    }\n\n    & ", " svg.csl-icon--inherit {\n      color: ", ";\n    }\n    \n    &.csl-list-item--inverse ", " svg.csl-icon--inherit {\n      color: ", ";\n    }\n  "])), pxToRem(40), theme["spacing_".concat($marginBottom)], StyledListItemBulletContainer, function (_ref2) {
    var theme = _ref2.theme;
    return theme.color_text_default_1;
  }, StyledListItemBulletContainer, function (_ref3) {
    var theme = _ref3.theme;
    return theme.color_text_inverse_default_1;
  });
});
export default styled.li(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", " {\n    ", "\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.cssPrefix;
}, StyledListItemCss);
export var StyledListItemBulletContainer = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", " {\n    left: -", ";\n    position: absolute;\n    top: 0;\n\n    & svg {\n      height: ", "rem;\n      width: ", "rem;\n    }\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.cssPrefix;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing_07;
}, pxToRem(8), pxToRem(8));
export var StyledListItemIconContainer = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", " {\n    left: -", ";\n    position: absolute;\n    top: 0;\n  }\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.cssPrefix;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.spacing_07;
});